import { RestResource } from "./common"
import { SchemaDeSer, SchemaDeSerBuilder } from "./deser"

export enum EXTERNAL_ACCOUNT_ASSET_CLASS_SCOPE {
  EVENT_CONTRACTS = "Event Contracts",
}

export enum EXTERNAL_ACCOUNT_ELIGIBILITY {
  ELIGIBLE = "Eligible",
  INELIGIBLE = "Ineligible",
  REQUIREMENTS_MISSING = "Requirements Missing",
}

export class ExternalAccountEligibility extends RestResource {
  assetClassScope = ""
  status?: EXTERNAL_ACCOUNT_ELIGIBILITY
  requirements: string[] = []
  reason?: string

  get isEligible() {
    return this.status === EXTERNAL_ACCOUNT_ELIGIBILITY.ELIGIBLE
  }

  get isIneligible() {
    return this.status === EXTERNAL_ACCOUNT_ELIGIBILITY.INELIGIBLE
  }

  get isRequirementsMissing() {
    return this.status === EXTERNAL_ACCOUNT_ELIGIBILITY.REQUIREMENTS_MISSING
  }
}

export const EXTERNAL_ACCOUNT_ELIGIBILITY_DESER: SchemaDeSer<ExternalAccountEligibility> =
  new SchemaDeSerBuilder(ExternalAccountEligibility)
    .ofString("assetClassScope")
    .ofString("id")
    .ofString("reason")
    .ofString("status")
    .ofPrimitiveArray("requirements")
    .toDeSer()
